import {
  Button,
  Link,
  Flex,
  Text,
  VStack,
  Image,
  Heading,
} from "@chakra-ui/react";
import React from "react";

// Edit this to change the announcement under the heading.
// Set it to "" to hide the announcement completely.
const ANNOUNCEMENT = "Our buffet prices are going down as of October 12, 2026";

function Landing({ announcement = ANNOUNCEMENT }) {
  return (
    <Flex
      height="100vh"
      align="center"
      justify={{ base: "center", md: "start" }}
      color="secondary"
      width="100%"
      position="relative"
      mt="100px"
    >
      <Flex
        direction="column"
        align={{ base: "center", md: "start" }}
        mb="15rem"
        zIndex={1}
      >
        <VStack
          fontFamily="heading"
          fontSize={{ base: "30px", md: "44px" }}
          letterSpacing={2}
          align={{ base: "center", md: "start" }}
        >
          <Heading
            fontFamily="heading"
            as="h1"
            fontWeight={700}
            mb="1rem"
            lineHeight={1}
          >
            GOLD BISTRO
          </Heading>
          <Heading
            fontFamily="heading"
            as="h1"
            fontWeight={700}
            mb="1rem"
            lineHeight={1}
          >
            CHINESE BUFFET
          </Heading>
        </VStack>

        {announcement && (
          <Text
            role="status"
            mt="1rem"
            px="0.75rem"
            py="0.75rem"
            maxW={{ base: "85vw", md: "520px" }}
            fontFamily="innerbody"
            fontWeight={500}
            fontSize={{ base: "14px", md: "16px" }}
            letterSpacing="0.5px"
            lineHeight={1.5}
            textAlign={{ base: "center", md: "left" }}
            color="white"
            bg="blackAlpha.700"
            border="1px solid"
            borderColor="accent"
            borderRadius={5}
          >
            {announcement}
          </Text>
        )}

        <Button
          as={Link}
          href="/menu.pdf"
          isExternal
          mt="2rem"
          fontFamily="body"
          fontWeight={700}
          bg="accent"
          color="primary"
          borderRadius={5}
          width={170}
          height={45}
          _hover={{
            color: "white",
            bg: "#ECAF09",
            textDecoration: "none",
          }}
        >
          VIEW MENU
        </Button>
      </Flex>

      <Flex
        position="absolute"
        height="100%"
        width="100%"
        justify={{ base: "center", md: "flex-end" }}
        opacity={{ base: "60%", md: "100%" }}
      >
        <Image
          src="yuan.png"
          objectFit="cover"
          objectPosition={{ base: "88%", md: "none" }}
          alt="garden"
        ></Image>
      </Flex>
    </Flex>
  );
}

export default Landing;
